import { Navigate, Route, Routes } from 'react-router-dom';
import { RoutePath } from './Routes';
import { Logout } from '../components/logout/Logout';

export const UnauthenticatedRouter = () => (
    <Routes>
        <Route
            path="*"
            element={<Navigate to={RoutePath.LOGIN} replace state={{ path: window.location.pathname }} />}
        />
        <Route path={RoutePath.LOGOUT} element={<Logout />} />
    </Routes>
);
